<div class="talent-page-wrapper">
    <!-- Header -->
    <header class="talent-header">
        <div class="logo-section">
            <ng-container *ngIf="roundDetails()?.round?.logo_url; else defaultLogo">
                <img [src]="roundDetails()?.round?.logo_url" alt="Company Logo"
                    style="max-height: 40px; max-width: 150px; object-fit: contain; margin-right: 10px;">
            </ng-container>
            <ng-template #defaultLogo>
                <div class="logo-icon">
                    <i class="bi bi-cpu-fill"></i>
                </div>
            </ng-template>
            <div class="logo-text">
                <h6>{{ roundDetails()?.tenant?.organization_name || 'Unacademy' }}</h6>
            </div>
        </div>
        <div class="secure-badge">
            <span class="dot"></span>
            Secure AI session
        </div>
    </header>

    <main class="talent-content">
        <!-- Title Section -->
        <div class="content-header-area ms-4">
            <!-- <div class="invitation-tag">
                <i class="bi bi-stars"></i>
                Interview Invitation
            </div> -->
            <h1 class="main-title">
                You're invited to interview at <span>{{ roundDetails()?.tenant?.organization_name || 'Unacademy'
                    }}</span>
            </h1>
        </div>

        <div class="row g-2 p-4">
            <!-- Left Column -->
            <div class="col-12 col-lg-8 accordion-area">
                <!-- Job Card -->
                <div class="job-card">
                    <div class="job-info-left">
                        <div class="company-initial">
                            {{ roundDetails()?.tenant?.initials || 'U' }}
                        </div>
                        <div class="job-details">
                            <p class="mb-1 fw-bold">{{ roundDetails()?.tenant?.organization_name || 'Unacademy' }}</p>
                            <h3>{{ roundDetails()?.round?.job_role || 'Product Manager' }}</h3>
                            <div class="job-meta-pills">
                                <div class="meta-pill">
                                    <i class="bi bi-briefcase"></i>
                                    {{ roundDetails()?.round?.experience || '3-5' }}
                                </div>
                                <div class="meta-pill">
                                    <i class="bi bi-clock"></i>
                                    {{ roundDetails()?.round?.total_duration_minutes || '30' }} min
                                </div>
                                <div class="meta-pill">
                                    <i class="bi bi-calendar-event"></i>
                                    Closes {{ (roundDetails()?.round?.valid_until | date:'MMM dd yyyy') || 'May 20,
                                    2026' }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- About Sections -->
                <mat-accordion multi>
                    <mat-expansion-panel [expanded]="true" class="custom-accordion">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <div class="accordion-header-content">
                                    <div class="accordion-icon">
                                        <i class="bi bi-briefcase"></i>
                                    </div>
                                    <span class="accordion-title">About the Role</span>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="accordion-body-text">
                            {{ roundDetails()?.round?.job_description || 'As a Product Manager, you will lead the
                            strategy and roadmap for our core learning experiences...' }}
                        </div>
                    </mat-expansion-panel>

                    <mat-expansion-panel class="custom-accordion" [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <div class="accordion-header-content">
                                    <div class="accordion-icon">
                                        <i class="bi bi-building"></i>
                                    </div>
                                    <span class="accordion-title">About the Company</span>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="accordion-body-text">
                            {{ roundDetails()?.tenant?.description || ((roundDetails()?.tenant?.organization_name || 'The company') + ' is
                            one of India\'s largest learning platforms, on a mission to democratize access to quality
                            education.') }}
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
                <div class="guidelines-card mt-3">
                <div class="guidelines-header">
                    <div class="header-icon">
                        <i class="bi bi-shield-check"></i>
                    </div>
                    <div>
                        <h2>Interview Guidelines</h2>
                        <p>Please review these guidelines before starting your interview.</p>
                    </div>
                </div>
                <h3 class="section-title">Before You Begin</h3>

                <div class="guideline-row mb-2">
                    <div class="row-icon">
                        <i class="bi bi-camera"></i>
                    </div>
                    <div class="row-content">
                        Allow camera and microphone access before continuing.
                    </div>
                </div>

                <div class="guideline-row mb-2">
                    <div class="row-icon">
                        <i class="bi bi-display"></i>
                    </div>
                    <div class="row-content">
                        Share your entire screen to begin the interview.
                    </div>
                </div>

                <div class="guideline-row mb-2">
                    <div class="row-icon">
                        <i class="bi bi-wifi"></i>
                    </div>
                    <div class="row-content">
                        Ensure a stable internet connection in a quiet, well-lit environment.
                    </div>
                </div>

                <h3 class="section-title">During the Interview</h3>

                <div class="guideline-card mb-2">
                    <div class="card-icon">
                        <i class="bi bi-person"></i>
                    </div>
                    <div>
                        <h4>Stay alone during the interview</h4>
                        <p>Only one person should be visible on camera throughout the interview.</p>
                    </div>
                </div>

                <div class="guideline-card mb-2">
                    <div class="card-icon">
                        <i class="bi bi-eye"></i>
                    </div>
                    <div>
                        <h4>Keep your face clearly visible</h4>
                        <p>Remain centered in the camera frame and avoid moving too far away.</p>
                    </div>
                </div>

                <div class="guideline-card mb-2">
                    <div class="card-icon">
                        <i class="bi bi-crosshair"></i>
                    </div>
                    <div>
                        <h4>Stay focused on the interview</h4>
                        <p>Avoid looking away from the screen for extended periods.</p>
                    </div>
                </div>

                <div class="guideline-card mb-2">
                    <div class="card-icon">
                        <i class="bi bi-window-stack"></i>
                    </div>
                    <div>
                        <h4>Do not switch tabs or applications</h4>
                        <p>Leaving the interview window or switching tabs may be treated as a violation.</p>
                    </div>
                </div>

                <div class="guideline-card mb-2">
                    <div class="card-icon">
                        <i class="bi bi-volume-mute"></i>
                    </div>
                    <div>
                        <h4>Maintain a quite environment</h4>
                        <p>Background conversations or multiple voices may affect your interview.</p>
                    </div>
                </div>

                <div class="guideline-card mb-2">
                    <div class="card-icon">
                        <i class="bi bi-arrow-clockwise"></i>
                    </div>

                    <div>
                        <h4>Do not refresh or close the page</h4>
                        <p>Refreshing or closing the interview window may interrupt your session.</p>
                    </div>
                </div>

                <div class="guideline-card mb-2">
                    <div class="card-icon">
                        <i class="bi bi-camera-video"></i>
            </div>

                    <div>
                        <h4>This interview is monitored and recorded</h4>
                        <p>AI-based proctoring is enabled throughout the interview to ensure a fair assessment.</p>
                    </div>
                </div>
             </div>
                </div>
            <!-- Right Column -->
            <div class="col-12 col-lg-4 ms-3">
       <div class="sidebar-area">
                <!-- CTA Card -->
                <div class="cta-card">
                    <span class="step-indicator">STEP 1 OF 4</span>
                    <h2>Ready to Start?</h2>
                        <p>Complete a quick setup in under a minute  to ensure everything is ready before AI Interview begins.
                        The interview will take approximately {{ roundDetails()?.round?.total_duration_minutes
                        || '30' }} minutes.</p>
                    <button class="start-btn" [class.expired-btn]="isExpired()" [disabled]="isExpired() || isStarting"
                        (click)="onStartClick()">
                        <ng-container *ngIf="!isExpired()">
                            <span *ngIf="!isStarting">Start Interview</span>
                            <span *ngIf="isStarting"><i class="bi bi-hourglass-split"></i> Starting...</span>
                            <i *ngIf="!isStarting" class="bi bi-arrow-right"></i>
                        </ng-container>
                        <ng-container *ngIf="isExpired()">
                            <span>Link Expired</span>
                            <i class="bi bi-x-circle"></i>
                        </ng-container>
                    </button>
                </div>

                <!-- Process List -->
                <div class="process-card">
                    <h5>
                        <i class="bi bi-info-circle text-primary"></i>
                        Application Process
                    </h5>
                    <ul class="process-list">
                        <li class="process-item">
                            <i class="bi bi-check2-circle check-icon"></i>
                            <span>Your interview summary will be shared with the hiring team for evaluation.</span>
                        </li>
                        <li class="process-item">
                            <i class="bi bi-check2-circle check-icon"></i>
                            <span>Only shortlisted candidates will proceed to the next stage of the hiring process.</span>
                        </li>
                        <li class="process-item">
                            <i class="bi bi-check2-circle check-icon"></i>
                            <span>If you retake the interview, your latest submission will replace previous attempts.</span>
                        </li>
                        <li class="process-item">
                            <i class="bi bi-check2-circle check-icon"></i>
                            <span>Your Interview will be conducted by an AI interviewer — respond naturally and clearly.</span>
                        </li>
                    </ul>
                </div>
                </div>
            </div>
        </div>
    </main>
</div>
<!-- Premium Language Selection Modal Overlay -->
<div *ngIf="showLanguageModal" class="premium-modal-overlay">
  <div class="premium-modal-container">
    <div class="premium-modal-header">
      <div class="language-icon-wrapper">
        <i class="bi bi-translate"></i>
      </div>
      <h2>Choose Your Interview Language</h2>
      <p>Select the language in which you would like to interact with the AI interviewer.</p>
    </div>

    <div class="language-options-grid">
      <div *ngFor="let lang of languages" 
           class="language-option-card"
           [class.active]="selectedLanguage === lang.code"
           (click)="selectLanguage(lang.code)">
        <div class="language-info">
          <span class="native-name">{{ lang.native_name || lang.name }}</span>
          <span class="english-name">{{ lang.name }}{{ lang.code === 'en' ? ' (Default)' : '' }}</span>
        </div>
        <div class="selection-indicator">
          <i class="bi bi-check-circle-fill" *ngIf="selectedLanguage === lang.code"></i>
          <span class="unselected-dot" *ngIf="selectedLanguage !== lang.code"></span>
        </div>
      </div>
    </div>

    <div class="info-alert-banner">
      <i class="bi bi-info-circle-fill"></i>
      <p>Once the interview begins, the language cannot be changed.</p>
    </div>

    <div class="premium-modal-actions">
      <button type="button" class="submit-btn" (click)="confirmLanguageSelection()" [disabled]="isStarting">
        <span *ngIf="!isStarting">Continue to Interview</span>
        <span *ngIf="isStarting"><i class="bi bi-hourglass-split"></i> Starting...</span>
        <i *ngIf="!isStarting" class="bi bi-arrow-right"></i>
      </button>
    </div>
  </div>
</div>
